import { captureExperimentExposure } from './util/experimentExposure';

export default function searchResults({ eventData, experimentExposure = null }) {
    return {
        init() {
            // null when the search is not in the experiment
            if (experimentExposure) {
                captureExperimentExposure(experimentExposure.key, experimentExposure.variant, experimentExposure.properties);
            }
            gtag('event', 'view_item_list', eventData);
        },
    };
}
